<template>
  <!-- 图文列表 -->
  <div class="main">
    <div>
      <div class="big-title-box">
        <div class="left">
          <div class="line" />
          <p class="title" @click="prime(notice.name)">{{ notice.name }}</p>
        </div>
      </div>
      <div v-if="articleList.length" style="min-height: 650px;">
        <!-- 图文 -->
        <div
          v-if="notice.showType == 1"
          class="card-list"
        >
          <div
            v-for="(item, index) in articleList"
            :key="index"
            class="card-item"
            @click="jumpNews(item.id, item.customUrl)"
          >
            <div class="img-box">
              <span
                :style="'background-image: url(' + cfg.imageDomain + item.img + ')'"
                alt
              /></div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-footer">
              <div class="custom-name">{{ item.source || item.author }}</div>
              <div class="publish-time">{{ item.publishedtime | parseTime('{y}-{m}-{d}') }}</div>
            </div>
          </div>
          <!-- 补空 -->
          <template v-if="articleList.length % 4 !== 0">
            <div v-for="item in (4 - articleList.length % 4)" :key="item" class="empty" />
          </template>
        </div>
        <!-- 文字列表 -->
        <div v-if="notice.showType == 0" class="ranking-list">
          <div v-for="item in articleList" :key="item.title">
            <div class="text-item">
              <a class="link" @click="jumpNews(item.id, item.customUrl)">
                <span class="doc" />
                <span>{{ item.title }}</span>
              </a>
              <span class="time">{{ time(item.publishedtime) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!end" style="margin-top:60px; text-align:center">
      <!-- <el-pagination
        background
        layout="prev, pager, next"
        :total="list.total"
        :page-size="15"
        :current-page="current"
        :hide-on-single-page="value"
        @current-change="handleCurrentChange"
      /> -->
      <el-button
        class="more-btn"
        size="medium"
        :disabled="moreBtnDisabled"
        @click.native="more"
      >
        查看更多
      </el-button>
    </div>
  </div>
</template>

<script>
import { getArticleList } from '@/api/common';
import { deleteHtmlTag, handlerStr } from '@/utils';
export default {
  props: {
    notice: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      pageSize: '',
      value: true,
      current: 1,
      end: false,
      list: {},
      name: '',
      nextName: '',
      articleList: [],
      moreBtnDisabled: false
    };
  },
  watch: {
    $route(to, from) {
      this.refresh(this.$route.query.name);
    }
  },
  created: function() {
    this.handleCurrentChange('refresh', this.current);
  },
  methods: {
    refresh() {
      this.current = 1;
      this.handleCurrentChange('refresh', this.current);
    },
    more() {
      this.handleCurrentChange('more', this.current);
    },
    time(timestamp) {
      const date = new Date(timestamp);
      const y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + MM + '-' + d + ' ';
    },
    handleCurrentChange(type, currentPage) {
      // this.list = ''
      // 辟谣专区等配置了 queryText 的栏目，用 queryText（多文案逗号并集）作为查询条件；其余沿用栏目名
      const routeName = this.$route.query.name;
      const label = (this.notice && this.notice.queryText) ? this.notice.queryText : routeName;
      this.nextName = routeName === '最新发布' ? '' : label;
      // 后端 total 恒为 0，末页只能靠「当页返回行数 < 页大小」判断
      const pageSize = 20;
      const data = { pageNo: currentPage, pageSize, customLabel: this.nextName, type: 16 };
      if (type !== 'refresh' && this.end) {
        this.moreBtnDisabled = true;
        return;
      }
      getArticleList(data).then(res => {
        const data = res.data;
        for (let i = 0; i < data.rows.length; i++) {
          data.rows[i].newContent =
            data.rows[i].newContent && this.handlerStr(data.rows[i].content);
        }
        if (type === 'refresh') {
          this.articleList = data.rows;
        } else {
          this.articleList = this.articleList.concat(data.rows);
        }
        // 末页判断：当页返回行数小于页大小，说明已无下一页（两分支统一口径）
        this.end = data.rows.length < pageSize;
        this.moreBtnDisabled = false;
        this.list = data;
        this.current = currentPage + 1
      });
    },
    jumpNews(id, customUrl) {
      if (customUrl) {
        var windowOpen = window.open();
        windowOpen.location = customUrl;
      } else {
        this.$router.push({ path: '/news', query: { id: id }});
      }
    },
    prime(name) {
      // 标题回查也保持并集：有 queryText 时改用 customLabel（与列表一致），否则维持原有 columnName 行为
      const label = (this.notice && this.notice.queryText) ? this.notice.queryText : name;
      this.nextName = label;
      const data = (this.notice && this.notice.queryText)
        ? this.buildParams({ pageNo: 1, pageSize: 15, customLabel: label })
        : this.buildParams({ pageNo: 1, pageSize: 15, columnName: name });
      getArticleList(data).then(res => {
        const data = res.data;

        for (let i = 0; i < data.rows.length; i++) {
          data.rows[i].newContent = this.handlerStr(data.rows[i].content);
        }
        this.list = data;
        this.articleList = data.rows;
      });
    },
    handlerStr(str) {
      return str && handlerStr(deleteHtmlTag(str), 200);
    }
  }
};
</script>

<style lang="less" scoped>
a {
  margin: 0;
  padding: 0;
  border: 0;
  color: #3c3c3c;
  font-size: 14px;
}
.main {
  overflow: hidden;
  width: 1200px;
  padding: 0;
  margin: 0 auto;
  position: relative;
}
@media screen and (max-width: 768px) {
  .main {
    width: 100%;
    max-width: 100%;
    padding: 0 10px;
  }
}

.big-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #0060B5;
  margin-top: 40px;
  .left{
    display: flex;
    align-items: center;
    .line{
      width: 16px;
      height: 40px;
      background: #008BF2;
      margin-right: 20px;
    }
    .title {
      // padding: 9px 28px;
      color: #0060B5;
      display: inline-block;
      font: 500 20px/22px PingFangSC;
      font-weight: bold;
    }
  }
}
// 文字列表
.ranking-list a.link {
  display: flex;
  align-items: center;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  white-space: nowrap;
}
.ranking-list a.link:hover {
  color: #367dbe;
  text-decoration: underline;
}
.ranking-list .text-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  border-bottom: 1px dashed #e5e5e5;
}
.ranking-list .text-item:hover .doc {
  background: #008bf2;
}
.ranking-list .doc {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cccccc;
  margin-right: 8px;
  display: inline-block;
}
.public_item_icon_img {
  width: 9px;
  height: 8px;
  margin: 5px;
  vertical-align: middle;
}
.ranking-list .time {
  font-size: 14px;
  color: #999;
}
.more-btn {
  width: 592px;
  height: 71px;
  border: 1px solid #0060b5;
  padding: 0 !important;
  line-height: 71px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  color: #0060b5;
}
@media screen and (max-width: 768px) {
    .more-btn {
      width: 100%;
      max-width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 18px;
    }
}
.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
  color: rgb(192, 196, 204) !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: rgb(255, 255, 255) !important;
  border-color: rgb(235, 238, 245) !important;
}
// 图文卡片
.card-list {
  width: 100%;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .empty{
    width: 23%;
    height: 285px;
  }
  .card-item {
    width: 23%;
    height: auto;
    min-height: 285px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.15);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    transition: all .2s linear;
    margin: 20px 0 ;
    &:nth-last-child(1){
      margin-right: 0;
    }
    > .img-box {
      span {
        width: 100%;
        height: auto;
        aspect-ratio: 280 / 210;
        display: block;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
    }
    > .card-title{
      width: 100%;
      height: 62px;
      padding: 10px 9px;
      background: #fff;
      white-space: pre-wrap;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      font: 400 16px/21px '宋体';
      color: #000;
    }
    .card-footer{
      display: flex;
      justify-content: space-between;
      margin: 10px 10px 0;
      padding: 7px 0 10px;
      border-top: 1px solid #E5E5E5;
      .custom-name{
        font-size: 12px;
        font-weight: 300;
        line-height: 16px;
        color: #999999;
      }
      .publish-time{
        font-size: 12px;
        font-weight: 300;
        line-height: 16px;
        color: #999999;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .ranking-list .text-item {
    padding: 10px;
    flex-direction: column;
    align-items: flex-start;

    .link {
      width: 100%;
      white-space: normal !important; // Allow wrap
    }

    .time {
      margin-top: 5px;
      font-size: 12px;
      align-self: flex-end;
    }
  }

  .card-list .card-item {
    width: 48%; // 2 columns
    min-height: 0 !important;
    margin: 0 0 12px 0 !important;
  }
  .card-list .card-item > .card-title {
    height: 40px !important;
    min-height: 40px !important;
    font-size: 14px !important;
    line-height: 20px !important;
    max-height: 40px !important;
    padding: 0 9px !important;
    box-sizing: border-box !important;
    white-space: normal !important;
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 2 !important;
    text-overflow: ellipsis !important;
    word-break: break-word !important;
    margin: 8px 0 !important;
  }
  .card-list .card-item .card-footer {
    display: block !important;
    text-align: left !important;
  }
  .card-list .card-item .card-footer .custom-name {
    width: 100%  !important;
    height: 32px !important;
    min-height: 32px !important;
    line-height: 16px !important;
    max-height: 32px !important;
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 2 !important;
    text-overflow: ellipsis !important;
    word-break: break-word !important;
    text-align: left !important;
  }
  .card-list .card-item .card-footer .publish-time {
    width: 100%;
    margin-top: 4px !important;
    text-align: left !important;
    display: block !important;
  }
  .card-list .empty {
    width: 48%;
  }
}

@media screen and (max-width: 480px) {
  .card-list .card-item {
    width: 48%; // 2 columns
  }
  .card-list .empty {
    width: 48%;
  }
}
.card-list .card-item:hover {
    box-shadow: 0 6px 6px #999;
    transform: translate3d(0,-2px,0);
  }
</style>
